import React, { useEffect, useState, useRef, useCallback } from "react";
import styled from "styled-components";
import { postAPIService } from "../API";
import { getProductsPayload } from "../../utils";
import constants from "../../constants";


const InfiniteProductList = ({ categoryId = "" }) => {
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const observer = useRef();

  const loaderRef = useRef();

  const getProductsCall = async (page) => {
    const URL = constants.Apis.getProductsList;
    const payload = getProductsPayload({ categoryId: 'AC001', curPage: page });
    try {
      const res = await postAPIService({ url: URL, data: payload });
      return res?.data;
    } catch (err) {
      console.error("API error:", err);
      return null;
    }
  };

  const loadMoreProducts = useCallback(async () => {
    if (loading || !hasMore) return;
    setLoading(true);
    const data = await getProductsCall(page);
    const newProducts = data?.productsList?.products || [];
    const totalCount = data?.productsList?.totalCount || 0;

    setProducts((prev) => [...prev, ...newProducts]);
    setPage((prev) => prev + 1);

    if ((page + 1) * 40 >= totalCount) setHasMore(false);
    setLoading(false);
  }, [page, loading, hasMore]);

  useEffect(() => {
    loadMoreProducts();
  }, []);

  useEffect(() => {
    if (loading) return;
    const currentLoader = loaderRef.current;

    const observerInstance = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && hasMore) {
          loadMoreProducts();
        }
      },
      { threshold: 1 }
    );

    if (currentLoader) observerInstance.observe(currentLoader);
    return () => currentLoader && observerInstance.unobserve(currentLoader);
  }, [loadMoreProducts, loading, hasMore]);

  return (
    <Wrapper>
      {products.map((product) => (
        <Card key={product?.id || Math.random()}>{product.name}</Card>
      ))}

      <Loader ref={loaderRef}>{loading && <p>Loading...</p>}</Loader>
    </Wrapper>
  );
};

export default InfiniteProductList;

// Styled Components
const Wrapper = styled.div`
  padding: 20px;
  max-width: 100vw;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Card = styled.div`
  background-color: #f6f6f6;
  padding: 16px;
  margin: 10px 0;
  width: 331px;
  aspect-ratio: 1 / 1;
  max-width: 600px;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
  font-size: 16px;
`;

const Loader = styled.div`
  padding: 20px;
  font-size: 14px;
  color: #555;
`;

